import * as React from 'react';
import Popup from "./Popup";
import {
    Box,
    Button,
    CircularProgress,
    DialogActions
} from "@mui/material";
import {useContext, useEffect, useState} from "react";
import API, {HandleError} from "../API";
import AppContext from "../AppContext";
import {useSnackbar} from "notistack";
import MailHistory from "./MailHistory";
import WhatsappHistory from "./WhatsappHistory";

export default function StudentWhatsapp({ popup, setPopup, children }) {
    const { enqueueSnackbar } = useSnackbar();
    const app = useContext(AppContext);
    const [history, setHistory] = useState([])

    useEffect(() => {
        if(popup.item?.ID && popup.reload)
            onLoad();

    }, [popup.item, popup.reload]) // eslint-disable-line react-hooks/exhaustive-deps

    const onLoad = async () => {
        setPopup({...popup, loading: true, reload: false, title: `Loading ${popup.item.full_name}'s WhatsApp history...` })
        try {
            const res = await API({
                method: 'GET', url: `/student/${popup.item.ID}/whatsapp`,
                headers: {
                    'Authorization': `Bearer ${app.token}`,
                },
                data: {}
            })

            if (res.status < 200 || res.status > 299)
                throw res.data;

            const history = res.data.results;

            setPopup({...popup, loading: false,  reload: false, title: `${popup.item.full_name} #${popup.item.ID}'s WhatsApp History`})
            setHistory(history)
        }
        catch(e) {
            onClose()
            HandleError(e, 'Load Student WhatsApp History', enqueueSnackbar, app.logout);
        }
    }

    const onClose = () => {
        setPopup({...popup, open: false, title: '', loading: false, reload: false });
        setHistory([])
    }

    const handleSubmit = (e) => {
        e.preventDefault();
    }

    return (
        <Popup popup={popup} setPopup={setPopup} onClose={onClose} dialogActions={<DialogActions>
            <div style={{flex: '1 0 0'}} />
            <Button onClick={onClose} disabled={popup.loading} sx={{color: (theme) => theme.palette.grey[700]}}>Close</Button>
        </DialogActions>}>
            {popup.loading || !popup.item?.ID ? <Box sx={{py: 6, textAlign: 'center'}}><CircularProgress /></Box> :
                <>
                    <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 1 }}>
                        <WhatsappHistory history={history} setHistory={setHistory} item={popup.item} />
                    </Box>
                    {children}
                </>}
        </Popup>
    )
}